/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { empty, errorResponse, isArray, prepareResponseData } from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";

// image
import student_avatar from "../../assets/avatars/profile_avatar.png";

// api
import classApi from "../../api/Classes";
import studentsApi from "../../api/Student";
import generalApi from "../../api/General";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import TableLoading from "../../components/skeleton/TableLoading";
import colors from "../../config/colors";
import { FaPrint, FaQrcode } from "react-icons/fa";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import FullPageLoader from "../../components/loader/FullPageLoader";

const printReport = () => {
  window.print();
};

const ClassBioData = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [studentsLoading, setStudentsLoading] = useState(false);
  const [classData, setClassData] = useState({});
  const [students, setStudents] = useState([]);
  const printRef = useRef();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { classId } = useParams();
  const toastTR = useRef(null);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!classId) {
      navigate("/404");
    }
  }, []);

  useEffect(() => {
    getClassDetails();
    getStudents();
  }, [classId]);

  const getClassDetails = async () => {
    try {
      if (!isLoading) setIsLoading(true);
      const response = await classApi.getSingleClass(classId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }
      setClassData(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : {}
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  const getStudents = async () => {
    try {
      if (!studentsLoading) setStudentsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await studentsApi.getStudentsInClass(schoolId, null, null, null, classId, null, null, classData?.isStream === true ? 'yes' : null);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStudents([]);
      }
      setStudents(
        !empty(response_data) &&
          !empty(response_data.response) &&
          isArray(response_data.response)
          ? response_data.response
          : []
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setStudentsLoading(false);
    }
  };

  /**
   * update qrcode
   * @returns
   */
  const updateQRCode = async (studentId) => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await generalApi.updateQRCode(
        studentId,
        schoolId,
        "students"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update qr-code!"
        );
      }

      responseDialog("success", "Success", "Update qr-code successfully.");

      return getStudents();
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {classData?.active ? (
            <>
              {/* menu header */}
              <MainHeader
                title={"Students` Photo Card: " + classData?.title || ""}
              />
              {/* end menu header */}
              {!studentsLoading ? (
                <>
                  <div>
                    <strong>Count: </strong>
                    {students?.length} student(s)
                  </div>
                  <ButtonIcon
                    buttonText="Print"
                    icon={<FaPrint />}
                    marginTop={3}
                    iconMarginRight={8}
                    backgroundColor="transparent"
                    color={colors.primary}
                    borderColor={colors.primary}
                    height={30}
                    width={150}
                    onClick={() => printReport()}
                  />
                  <section className="students-bio-data mt-20 flex direction-row" ref={printRef} style={{ flexWrap: 'wrap', columnGap: '2%' }}>
                    {students?.map((data, index) => {
                      return (
                        <div
                          key={data?._id || index}
                          className="flex direction-row mb-10 students-photo-card"
                        >
                          <div>
                            <div
                              className="mb-10"
                              style={{ width: 180, height: "auto" }}
                            >
                              <img
                                style={{ width: "100%" }}
                                src={data?.avatar || student_avatar || ""}
                                alt="avatar"
                              />
                            </div>
                            <div>
                              <strong>FullName:</strong> {data?.fullName || 'NA'}
                            </div>
                            <div className="mt-10">
                              <strong>Reg. No.:</strong> {data?.regNo || 'NA'}
                            </div>
                            <div className="mt-10">
                              <strong>Class:</strong> {classData?.title || 'NA'}
                            </div>
                            <div className="mt-10">
                              <strong>Gender:</strong> {classData?.gender || 'NA'}
                            </div>
                          </div>
                          <div
                            style={{
                              width: 200,
                              height: "auto",
                              flex: 1,
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            {data?.qrCodePath ? (
                              <img
                                style={{ width: 250, height: 250 }}
                                src={data?.qrCodePath || ""}
                                alt="qr code"
                              />
                            ) : (
                              <div
                                className="flex direction-column align-center"
                              >
                                <div
                                  className="mb-20 flex direction-column align-center"
                                >
                                  <FaQrcode size={120} />
                                 <span className="text-danger">No available qrcode.</span>
                                </div>
                                <div className="exclude-print">
                                  <ButtonIcon
                                    height={40}
                                    color={colors.primary}
                                    backgroundColor={colors.lightgray}
                                    width={160}
                                    marginTop={-1}
                                    fontSize={12}
                                    borderColor="transparent"
                                    buttonText="Update QR-Code"
                                    iconMarginRight={8}
                                    icon={<FaQrcode size={12} />}
                                    fontWeight="bold"
                                    onClick={() => updateQRCode(data?._id)}
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </section>
                </>
              ) : (
                <TableLoading cols={3} rows={20} />
              )}
            </>
          ) : (
            <div>
              {/* you don't have access to this class or it is inactive */}
            </div>
          )}
        </main>
        {isLoading && <FullPageLoader visible={isLoading} />}
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default ClassBioData;
